import Vue from 'vue'
import Router from 'vue-router'
import LayoutRouter from '@/components/LayoutRouter'
import LayoutFull from '@/components/LayoutFull'
import LayoutOnlyOwnMedia from '@/components/LayoutOnlyOwnMedia'
import Login from '@/components/User/Login'
import RecoverPassword from '@/components/User/RecoverPassword'
import ChangePassword from '@/components/User/ChangePassword'
import UserList from '@/components/User/List'
import FileUpload from '@/components/File/Upload'
import FileList from '@/components/File/List'
import FreePlayListPreview from '@/components/Medium/FreePlayListPreview'
import FreeMediaPreview from '@/components/Medium/FreeMediaPreview'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/layout/*',
      redirect: '/layout-router/'
    },
    {
      path: '/',
      redirect: '/layout-router/'
    },
    // {
    //   path: '/layout/:leftPanel/:rightPanel',
    //   name: 'Layout',
    //   component: Layout,
    //   props: true,
    //   meta: { requiresAuth: true }
    // },
    {
      path: '/layout-router/',
      name: 'Layout-Router',
      // component: Layout,
      component: LayoutRouter,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/layout-full/:leftPanel/:rightPanel/:mediumEditor',
      name: 'Layout-Full',
      // component: Layout,
      component: LayoutFull,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/layout-config/',
      name: 'Layout-Config',
      // component: Layout,
      component: LayoutOnlyOwnMedia,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/recoverpassword/:type',
      name: 'RecoverPassword',
      component: RecoverPassword,
      meta: { requiresAuth: false }
    },
    {
      path: '/playlistpreview/:token',
      name: 'FreePlayListPreview',
      component: FreePlayListPreview,
      meta: { requiresAuth: false }
    },
    {
      path: '/freepreview/:network/:width/:height/:scale',
      name: 'FreeMediaPreview',
      component: FreeMediaPreview,
      meta: { requiresAuth: false }
    },
    {
      path: '/changePassword/:token/:email',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: { requiresAuth: false }
    },
    {
      path: '/users',
      name: 'UserList',
      component: UserList,
      meta: { requiresAuth: true }
    },
    {
      path: '/fileupload',
      name: 'FileUpload',
      component: FileUpload,
      meta: { requiresAuth: true }
    },
    {
      path: '/files',
      name: 'FileList',
      component: FileList,
      meta: { requiresAuth: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js